import { Tooltip } from '@mui/material';
import { any, bool } from 'prop-types';
import React from 'react';

const TooltipIfDisabled = ({ children, disabled = false, ...rest }) =>
  disabled ? <Tooltip {...rest}>{children}</Tooltip> : <>{children}</>;

TooltipIfDisabled.propTypes = {
  children: any.isRequired,
  disabled: bool,
};

export default TooltipIfDisabled;
